import { EventInput } from "@fullcalendar/core";

export const EVENT_STYLES = {
  backgroundColor: "rgb(218, 243, 255)", //"rgb(255, 236, 238)",
  textColor: "rgb(29, 107, 183)",
  borderColor: "rgb(218, 243, 255)", //"rgb(255, 236, 238)",
  classNames: ["default-schedule-event"],
};

export const EVENT_STYLES_CANCELED = {
  backgroundColor: "rgb(255, 236, 238)", //"rgb(255, 236, 238)",
  textColor: "rgb(172, 0, 0)",
  borderColor: "rgb(255, 236, 238)", //"rgb(255, 236, 238)",
  classNames: ["default-schedule-event"],
};

export const EVENT_STYLES_PAID = {
  backgroundColor: "rgb(211, 248, 229)", //"rgb(255, 236, 238)",
  textColor: "rgb(0, 90, 17)",
  borderColor: "rgb(211, 248, 229)", //"rgb(255, 236, 238)",
  classNames: ["default-schedule-event"],
};

export const SCHEDULE_STATUS = [
  { name: "Confirmado", value: "CONFIRMED" },
  { name: "Cancelado", value: "CANCELED" },
  { name: "Pago", value: "PAID" },
];

let eventGuid = 0;
let todayStr = new Date().toISOString().replace(/T.*$/, ""); // YYYY-MM-DD of today

export const INITIAL_EVENTS: EventInput[] = [
  {
    id: createEventId(),
    title: "All-day event",
    start: todayStr,
    backgroundColor: "rgb(255, 236, 238)",
    textColor: "rgb(172, 0, 0)",
    borderColor: "rgb(255, 236, 238)",
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00",
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00",
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00",
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00",
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00",
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00",
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00",
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00",
  },
];

export function createEventId() {
  return String(eventGuid++);
}
